var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * react-final-form：1フィールドに対し、複数のバリデーションを渡すための関数
 * 例： validate={composeValidators(isFoo, isBar, isBaz)}
 * @description 実行したくない場合は null を指定してください
 * @param validators
 */
export const composeValidators = (...validators) => (value, allValues, meta) => validators
    .filter((validator) => validator !== null)
    .reduce((error, validator) => error || validator(value, allValues, meta), undefined);
/**
 * react-final-form：1フィールドに対し、複数のバリデーションを渡すための関数（非同期用）
 * @description 非同期バリデーションがある場合こちらを使用してください
 * @description FieldArray では挙動が安定しないため、使用しないでください
 * @param validators
 */
export const composeAsyncValidators = (...validators) => (value, allValues, meta) => __awaiter(void 0, void 0, void 0, function* () {
    const filters = validators.filter((validator) => validator !== null);
    for (let i = 0; i < filters.length; i += 1) {
        const runValidate = filters[i];
        // eslint-disable-next-line no-await-in-loop
        const currentError = yield runValidate(value, allValues, meta);
        if (currentError) {
            return currentError;
        }
    }
    return undefined;
});
